import { ILogService } from 'angular'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { MainQuestion } from 'src/_candidato/data/main-question'
import { IFilaCV, IListadoCV, IModelMainQuestion } from 'src/model/candidato-api'
import { BaseFeaturesComponent } from './base-features.component'
import { FILTROS, Filtro } from './filtros'

export abstract class BaseFiltrosComponent extends BaseFeaturesComponent {
  listado: IListadoCV | null = null
  listadolist: IFilaCV[] = []
  filtrosList: typeof FILTROS
  filtroActivo: Filtro | null = null

  filtroFechas = {
    visible: false,
    inicio: null as Date,
    fin: null as Date,
  }

  mainq = {
    $load: null as PromiseLike<IModelMainQuestion[]>,
    list: [] as MainQuestion[],
  }

  filtroQ = {
    visible: false,
    mainq: null as number,
    value: null as string,
  }

  constructor(
    protected $log: ILogService,
    appConfigService: AppConfigService
  ) {
    super(appConfigService)
  }

  aplicaFiltros() {
    this._busqueda()
  }

  abstract _busqueda(): void
  abstract _updateSelect(): void
  abstract _actualizaMainQ(): void

  filtrarFechas(forzar?: boolean) {
    this.filtroFechas.visible = forzar ?? !this.filtroFechas.visible
  }

  filtrarPorMainQ(forzar?: boolean) {
    this.filtroQ.visible = forzar ?? !this.filtroQ.visible

    if (this.filtroQ.visible && this.mainq.list.length) {
      this.filtroQ.mainq = this.mainq.list[0].data_mq.idmainq

      this._updateSelect()
    }
  }
}
